import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import { getDocumentURL } from "../../handler/ParentDataHandler";
import FormattedMetric from "../../common/FormattedMetric";

export default function NumberWidget({ widgetSpec, metricData }) {
  const isEditMode = useSelector((state) => state.isEditMode);
  const widgetDefinition = widgetSpec.widgetDefinition;
  // Validate metricData is not null/undefined before using
  if (!metricData || !Array.isArray(metricData)) {
    return null;
  }

  const totalMetricValues = metricData.reduce((total, metric) => {
    return (
      total + (metric && metric.metricValues ? metric.metricValues.length : 0)
    );
  }, 0);

  if (totalMetricValues === 0) {
    return null;
  }

  const gridX = Math.floor(12 / totalMetricValues);
  const gridWidths = Array(totalMetricValues).fill(`grid-${gridX}`);

  // Get metric definitions from widgetDefinition for drilldown configuration
  const metricDefinitions =
    (widgetDefinition && widgetDefinition.metrics) || [];

  // Flatten all metric values for easier processing
  const allMetricValues = metricData.flatMap((metric, metricIndex) => {
    if (!metric || !metric.metricValues) return [];

    const metricDefinition = metricDefinitions[metricIndex] || {};

    return metric.metricValues.map((metricValue, valueIndex) => ({
      ...metricValue,
      key: `${metricIndex}-${valueIndex}-${metricValue.name || valueIndex}`,
      metricDefinition,
    }));
  });

  // Handle metric click for drilldown functionality
  const handleMetricClick = useCallback((metricValue) => {
    const { metricDefinition } = metricValue;

    // Check if drilldown pathname is configured
    if (!metricDefinition || !metricDefinition.drilldown) {
      return;
    }

    getDocumentURL().then((currentUrl) => {
      const urlObj = new URL(currentUrl);
      urlObj.pathname = metricDefinition.drilldown;
      window.open(urlObj.toString(), "_parent");
    });
  }, []);

  return (
    <Box>
      {/* Row for display names */}
      <Row widths={gridWidths} alignmentVertical="top">
        {allMetricValues.map((metricValue) => (
          <Box key={`name-${metricValue.key}`}>
            <Text type="b100">{metricValue.displayName}</Text>
          </Box>
        ))}
      </Row>

      {/* Row for metric values */}
      <Row widths={gridWidths} alignmentVertical="top">
        {allMetricValues.map((metricValue) => {
          const hasClickableValue =
            metricValue.value !== undefined &&
            metricValue.value !== null &&
            metricValue.metricDefinition &&
            metricValue.metricDefinition.drilldown;

          // Disable clicks when in edit mode
          const shouldShowClickable = hasClickableValue && !isEditMode;

          return (
            <Box key={`value-${metricValue.key}`}>
              {shouldShowClickable ? (
                <Link
                  type="secondary"
                  onClick={() => handleMetricClick(metricValue)}
                >
                  <Text type="d50" color="#000000">
                    <FormattedMetric
                      value={metricValue.value}
                      unit={metricValue.unit}
                    />
                  </Text>
                </Link>
              ) : (
                <Text type="d50">
                  <FormattedMetric
                    value={metricValue.value}
                    unit={metricValue.unit}
                  />
                </Text>
              )}
            </Box>
          );
        })}
      </Row>
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/components/mySCC/components/NumberWidget.js